<template>
  <div>
    <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:create:success="postFile"
               @submit:update:success="postFile" @fetchOptions="fetchOptions" @resetOptions="resetOptions"></AdminForm>
  </div>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "BusinessReturnForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        agency_number: null,
        business_number: null,
        status_slug: null,
        axiloc_creation_date: this.$moment().format("YYYY-MM-DD"),
        material_retrieving_place: null,
        return_warehouse_id: null,
        stored_files: [],
        unique_references: [{ id: null }],
      },
      isBusy: false,
      initialForm: {},
    };
  },
  computed: {
    options: function () {
      return {
        material_retrieving_place_options: this.$store.getters["business_return/getMaterialRetrievingPlaces"],
        return_warehouse_id_options: this.$store.getters["warehouse/getAll"].selectOptions("id", [
          "internal_code",
          " - ",
          "name",
        ]),
        agency_number_options: this.$store.getters["agency/getAll"].selectOptions(
          "internal_number",
          ["internal_number", " - ", "name"]
        ),
        status_slug_options: this.$store.getters["status/getByGroup"]("business-return")
          .filter((item) => item.status_slug !== "business-return-receptionnee")
          .selectOptions("status_slug", "name"),
        id_options: this.$store.getters["reference/getAll"]
          .selectOptions("id", ["product.name", " - ", "internal_code"])
          .concat(
            this.initialForm.unique_references &&
              this.initialForm.business_number == this.form.business_number
              ? this.initialForm.unique_references.selectOptions("id", [
                "product.name",
                " - ",
                "internal_code",
              ])
              : []
          ),
        business_number_options: this.$store.getters["business/getByAgencyNumber"](
          this.form.agency_number
        ).selectOptions("number", ["number", " - ", "name"]),
        user_id_options: _.orderBy(
          this.$store.getters["user/getByStatusSlug"]("user-active").selectOptions("id", [
            "firstname",
            " ",
            "lastname",
            " (",
            "employee.number",
            ")",
          ]),
          "text"
        ),
      };
    },
  },
  watch: {
    "form.agency_number": function (agency) {
      this.$store
        .dispatch("business/getAllForSelectByAgencyNumber", {
          wait: true,
          agency: agency,
        })
        .then(() => {
          this.options.business_number_options = this.$store.getters["business/getByAgencyNumber"](
            agency
          ).selectOptions("number", ["number", " - ", "name"]);
        });
    },
    "form.business_number": function (business) {
      this.$store.dispatch("reference/getAllByBusinessNumber", {
        wait: true,
        business: business,
        secondary_api_data_path: this.form.id ? 'references.return_in_progress' : null,
      });
    },
    "form.unique_references": {
      // This will let Vue know to look inside the array
      deep: true,
      handler() {
        this.updateDeliveryFormState();
      },
    },
  },
  mounted() {
    let self = this;

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_number: item.agency ? item.agency.internal_number : null,
            business_number: item.business ? item.business.number : null,
            user_id: item.user ? item.user.id : null,
            return_warehouse_id: item.return_warehouse ? item.return_warehouse.id : null,
            initial_return_warehouse_id: item.return_warehouse ? item.return_warehouse.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            withdraw_wished_date: item.withdraw_wished_date
              ? this.$moment(item.withdraw_wished_date).format("YYYY-MM-DD")
              : null,
            stored_files: item.stored_files || []
          };

          this.$store.dispatch("business/getAllForSelectByAgencyNumber", {
            agency: item.agency.internal_number,
          });
          this.$store.dispatch("reference/getAllByBusinessNumber", {
            business: item.business.number,
            secondary_api_data_path: 'references.return_in_progress',
            wait: true
          }).then(() => {
            this.updateDeliveryFormState();
          });
          if (item.user) {
            this.$store.dispatch("user/getItem", {
              id: item.user.id,
            });
          }

          // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
          // les utiliser dans la gestion des fichiers joints
          this.initialForm = _.cloneDeep(this.form);
          this.isBusy = false;
        });
    }

    this.$store.dispatch("agency/getAllForSelect");
    this.$store.dispatch("warehouse/getAll");
  },
  methods: {
    updateDeliveryFormState() {
      let allChronopost = true;
      let totalWeight = 0;
      this.form.unique_references.forEach((unique_reference) => {
        if (unique_reference.id) {
          const reference = this.$store.getters["reference/getItem"](unique_reference.id);
          if (reference && reference.product) {
            if (reference.product.return_mode == "transporter") {
              allChronopost = false;
            }
            totalWeight = totalWeight + reference.product.weight;
          }
        }
      });
    },
    postFile(response) {
      // Si il ya des fichiers
      if (this.form.stored_files) {
        this.form.stored_files.forEach((fileLine) => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!fileLine.id) {
            let item = {
              business_return_id: response.data.object.id,
              type_slug: "business-return",
              format: fileLine.file.type,
              file: fileLine.file,
            };

            this.$store.dispatch("stored_file/addItem", item);
          }
        });

        // Gestion des fichiers supprimés
        // On compare les données du formulaire avant modification avec mes données modifiées
        // pour identifier les fichiers supprimés
        if (this.initialForm.stored_files) {
          this.initialForm.stored_files.forEach((fileLine) => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.stored_files.find((item) => item.id == fileLine.id)) {
              this.$store.dispatch("stored_file/deleteItem", fileLine.id);
            }
          });
        }
      }
    },
    fetchOptions(field_name, search, loading) {
      if (field_name == 'user_id') {
        this.$store.dispatch("user/getAllForSelectBySearch", { wait: true, search: search })
          .then(() => {
            if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
              this.$store.dispatch("user/getItem", {
                id: this.form.user_id,
              });
            }
          })
      }
    },
    resetOptions(field_name) {
      if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
        this.$store.dispatch("user/getItem", {
          id: this.form.user_id,
        });
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BusinessReturn/BusinessReturnForm.vue